import MgoCheckbox from '@humanforce/mango-ui/dist/react/checkbox/index.js';
import { asMangoElement } from './mango';

const MangoCheckbox = asMangoElement(MgoCheckbox);

interface CheckboxProps {
  checked: boolean;
  id: string;
  label: string;
  disabled?: boolean;
  helpText?: string;
  onChange: (checked: boolean) => void;
}

export const Checkbox = ({ checked, disabled, helpText, id, label, onChange }: CheckboxProps) => {
  const handleChange = (event: Event) => {
    const target = event.target as HTMLElement & { checked?: boolean };
    const detail = (event as CustomEvent<{ checked?: boolean }>).detail;
    onChange(detail?.checked ?? Boolean(target.checked));
  };

  return (
    <div className="flex flex-col gap-1">
      <MangoCheckbox checked={checked} data-label={label} disabled={disabled ? true : undefined} id={id} onMgoChange={handleChange}>
        {label}
      </MangoCheckbox>
      {helpText && <p className="m-0 text-sm text-neutral-secondary-foreground">{helpText}</p>}
    </div>
  );
}
